var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSponsoricon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.3414,
    cy: 30.0592,
    r: 28.5592,
    fill: "#D7D7D7",
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9976 40.7151V36.4963C42.9976 34.2585 42.3309 32.1123 41.1441 30.5299C39.9573 28.9476 38.3477 28.0586 36.6693 28.0586H24.0128C22.3345 28.0586 20.7249 28.9476 19.5381 30.5299C18.3513 32.1123 17.6846 34.2585 17.6846 36.4963V40.7151",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.341 24.8948C33.836 24.8948 36.6692 22.0615 36.6692 18.5665C36.6692 15.0715 33.836 12.2383 30.341 12.2383C26.846 12.2383 24.0127 15.0715 24.0127 18.5665C24.0127 22.0615 26.846 24.8948 30.341 24.8948Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsoricon);
export default __webpack_public_path__ + "static/media/sponsoricon.d71542e45a4f937629451680da9b417d.svg";
export { ForwardRef as ReactComponent };